export default function ExercisePreviewLightbox({ exercise, mediaBlobUrl, onClose }) {
  if (!exercise || !mediaBlobUrl) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="exercise-media-preview"
    >
      <div className="max-w-3xl max-h-[85vh] relative" onClick={(e) => e.stopPropagation()}>
        <img
          src={mediaBlobUrl}
          alt={exercise.name}
          className="max-w-full max-h-[80vh] object-contain rounded-lg"
        />
        <div className="mt-3 text-center">
          <p className="text-white font-semibold">{exercise.name}</p>
          <div className="flex justify-center gap-2 mt-1">
            {exercise.category && (
              <span className="text-[11px] px-2 py-0.5 bg-[#007AFF]/10 text-[#007AFF] rounded-full">
                {exercise.category}
              </span>
            )}
            {exercise.muscle_group && (
              <span className="text-[11px] px-2 py-0.5 bg-[#D4FF00]/10 text-[#D4FF00] rounded-full">
                {exercise.muscle_group}
              </span>
            )}
          </div>
        </div>
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-white/70 hover:text-white text-sm"
          data-testid="close-media-preview"
        >
          Chiudi
        </button>
      </div>
    </div>
  );
}
